import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box, Grid } from "@mui/material";
import { NavDrawerButton } from "../navigation/SideNav";
import UserMenu from "../navigation/UserMenu";
import "./TopBar.scss";
export const TopBar = () => {
    return (_jsx("header", { children: _jsxs(Grid, { container: true, sx: {
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "nowrap",
                bgcolor: "#F4EFFB",
                paddingBottom: 3,
                paddingTop: 3,
                maxHeight: "80px"
            }, children: [_jsx(Grid, { size: {
                        sm: "auto"
                    }, children: _jsx(Box, { sx: { display: "flex", alignItems: "center" }, children: _jsx(NavDrawerButton, {}) }) }), _jsx(Grid, { size: {
                        sm: "auto"
                    }, children: _jsx(UserMenu, {}) })] }) }));
};
